module.exports = webappBundle("configuration/workday/wizard/mapping/manual-organization-team-mapping-modal/manual-organization-team-mapping-modal.css");